import React, { FC, useState, ChangeEvent, KeyboardEvent } from 'react'
import { useRouter } from 'next/router'
import { client } from '@/sanity/lib/client'
import Button from '../UI/button/Button'
import NextImage from '../UI/nextImage/NextImage'
import styles from './SearchBar.module.scss'
import { searchQuery } from '@/src/assets/queries/searchQuery'
import search from '@/public/search.svg';

type TSearchbar = {
  isSearchOpen: boolean
  setIsSearchOpen: (isSearchOpen: boolean) => void
}

const SearchBar: FC<TSearchbar> = ({isSearchOpen, setIsSearchOpen}) => {
  const searchClassName = isSearchOpen ? `${styles.header__search} ${styles.search__open}` : `${styles.header__search}`

  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');

  const router = useRouter()

  const handleButtonClick = () => {
    if (!searchValue) {
      setIsSearchOpen(!isSearchOpen)
    } else {
      setIsSearchOpen(false)
      router.push(`/results/${searchValue}`);
      setSearchValue('')
    }
  };

  const handleSearch = async (event: ChangeEvent<HTMLInputElement>) => {
      const query = event.target.value
      setSearchValue(query)
      try {
        const response = await client.fetch(searchQuery(query))
        setSearchResults(response)
      } catch (error) {
        console.error(error)
      }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleButtonClick(); 
    }
  };

  return (
    <div className={searchClassName}> 
      <Button
        ariaLabel='Search'
        className={`${styles.search__btn}`}
        onClick={handleButtonClick}
      >
        <NextImage 
            src={search}
            alt='Search'
            width={24}
            height={24}
        />
      </Button>
      <input 
        className={styles.search__inp} 
        type="text" 
        placeholder="Search ..."
        value={searchValue}
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
      />
    </div>
  )
}

export default SearchBar